export default "__VITE_ASSET__jNMYpK0x__"